import { render } from "./DeviceStock.vue?vue&type=template&id=58b885ce&scoped=true&ts=true&lang=pug"
import script from "./DeviceStock.vue?vue&type=script&lang=ts"
export * from "./DeviceStock.vue?vue&type=script&lang=ts"

import "./DeviceStock.vue?vue&type=style&index=0&id=58b885ce&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b885ce"]])

export default __exports__